// extracted by mini-css-extract-plugin
export default {"btn":"DefaultButton_btn__-PxBy"};